<template>
  <div class="book">
    <div class="coverInfo">
      <img class="coverImage" src="//textcafe.co/books/hFbOSQ/tc-custom/9780814347898.jpg?1725909135123" alt="This image is the cover for the book Parks and Recreation, TV Milestones"/>
    </div>
    <div class="bookInfo">
      <h1 class="bookTitle heading font1">Parks and Recreation, TV Milestones
      </h1>
      <p class="bookDescription body article font2">
        <p> <b>"Treat yo' self" to this captivating analysis of critically acclaimed, fan-favorite television series <i>Parks and Recreation</i>.</b> </p><p>An homage to <i>Parks and Recreation</i> (2009–15) and an exploration of how the show evolved as a traditional network sitcom in a post-network era. This deep dive into the series highlights the new norm of digital fandom, where social media has become a means for fans to engage with the series beyond its runtime. While the media landscape evolved, so did American sociopolitical discourse; Holladay examines the series contained entirely within Barack Obama's presidency as it reflects the role of politics in American life on a micro scale. </p><p> <br/>The series follows the career and personal life of Leslie Knope (Amy Poehler), a self-possessed, midlevel bureaucrat whose initial ideology reflects the optimistic tone of politics ushered in with Obama's campaign and early presidency. Throughout its run, <i>Parks and Recreation</i> engaged with political debates simmering in American culture, offering a humorous ripped-from-the-headlines take on issues such as same-sex marriage, distrust of politicians, government shutdowns, and corporate bailouts Through compelling analysis, Holladay untangles representations of women and BIPOC in the series as they engage with contemporary discourse surrounding media and identity politics.</p>
      </p>
    </div>
    <div class="authorInfo">
      <h2 class="authorName heading font1">
        Holly Willson Holladay
      </h2>
      
      
    </div>
    <div class="publisherInfo">
     <h2 class="publisherName heading font1">
      Wayne State University Press
     </h2>
        
        
     
    </div>
  </div>
</template>

<script>
// import Navigation from '@/components/Navigation'
export default {
  name: 'home',
  data() {
    return {}
  },
  components: {
    // 'navigation': Navigation
  }
}
</script>


// WEBPACK FOOTER //
// home.vue?5a3d9fce